export type FixedAssetType = 'TANGIBLE' | 'INTANGIBLE'

export interface CatalogItem {
  id: number
  name: string
}

/** A unit as stored: the code of a listed unit, or the text written by hand when it is not listed. */
export interface StoredUnit {
  code: string | null
  other: string | null
}

export interface ProductDetail {
  name: string
  number: string | null
  type: string
  unit: StoredUnit
  content: number | null
  contentUnit: StoredUnit
  hasSpecialTaxes: boolean
  isFixedAsset: boolean
  fixedAssetType: FixedAssetType | null
  selectedCategories: CatalogItem[]
  categories: CatalogItem[]
  selectedSubcategories: CatalogItem[]
  subcategories: CatalogItem[]
  societyIds: number[]
}

export interface ProductSaveRequest {
  name: string
  number: string | null
  type: string
  /** A listed unit's code, or any other text: the api keeps it as written. */
  unit: string | null
  content: number | null
  contentUnit: string | null
  hasSpecialTaxes: boolean
  isFixedAsset: boolean
  fixedAssetType: FixedAssetType | null
  /** On update, societies already linked stay: the api only adds. */
  societyIds: number[]
  /** Ids of existing categories, or names of the ones to create. */
  selectedCategories: (number | string)[]
  selectedSubcategories: (number | string)[]
}

/** The products page the api answers a save with; the legacy table reads it as is. */
export type ProductsPage = Record<string, unknown>

export class ProductSaveError extends Error {}

export interface ProductRepository {
  get(id: number): Promise<ProductDetail>
  create(request: ProductSaveRequest): Promise<ProductsPage>
  update(id: number, request: ProductSaveRequest): Promise<ProductsPage>
}
